let language = {
    DETAIL_PRICE_TITLE: "Products price",
    DETAIL_PRICE_LIST_TITLE: "Tiered Price Table",
    DETAIL_EXCL: "( excel.VAT )",
    DETAIL_PRICE_TITLE_MOBILE: "Price:",
    DETAIL_EXCL_MOBILE: "( excel.VAT )",    
    DETAIL_PRICE_LIST_TITLE_MOBILE: "Tiered Price Table",
    DETAIL_PRICE_ITEM_TITLE_QTY: "Qty",
    DETAIL_PRICE_ITEM_TITLE_US: "US",
    DETAIL_PRICE_ITEM_TITLE_OTHERS: "Others",
    DETAIL_PRICE_ITEM_TITLE_PRICE:"Price",
    DETAIL_EMPTY_PRICE: "Tiered price table is empty.",
    DETAIL_MOQ_TIP:"The minimum order quantity is",
    DETAIL_MOQ_TIP_MOBILE:"The minimum order quantity is",
    DETAIL_VIEW_BULK_PRICE:"FlexiBulk Savings Program"

}

export { language }